import Frictiescan from './Frictiescan';

function App() {
  return <Frictiescan />;
}

export default App;
